var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { ref: "modal", staticClass: "modal fade", attrs: { role: "dialog" } },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h4", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.$t("dutyAdvancedNotification")))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.advancedReminderHours,
                    expression: "advancedReminderHours"
                  }
                ],
                ref: "dropdown",
                staticClass: "form-control",
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.advancedReminderHours = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { domProps: { value: 0 } }, [
                  _vm._v(_vm._s(_vm.$t("generalDisabled")))
                ]),
                _vm._v(" "),
                _c("option", { domProps: { value: 24 } }, [
                  _vm._v(_vm._s("1 " + _vm.$t("generalDay")))
                ]),
                _vm._v(" "),
                _c("option", { domProps: { value: 120 } }, [
                  _vm._v(_vm._s("5 " + _vm.$t("generalDays")))
                ]),
                _vm._v(" "),
                _c("option", { domProps: { value: 720 } }, [
                  _vm._v(_vm._s("30 " + _vm.$t("generalDays")))
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                attrs: { type: "button" },
                on: { click: _vm.dismiss }
              },
              [_vm._v(" " + _vm._s(_vm.$t("btnCancel")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                ref: "createButton",
                staticClass: "btn btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.save }
              },
              [_vm._v(" " + _vm._s(_vm.$t("btnSave")))]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }